import { Component, OnInit, Input } from '@angular/core';
import { BaseRequest } from '../../models/base-request.model';
import { ActivatedRoute } from '@angular/router';
import { BaseRequestService } from '../../../front-user/shipyard-service/services/base-request.service';
import { Languages, PenaltyStatus, RegisterType, Service } from '../../models/enums.model';
import { GlobalServices } from '../../services/global.service';
import { AuthenticationService } from '../../../front-user/shared/services/authentication.service';
import { User } from '../../../front-user/shared/models/user.model';
import { AgentService } from '../../../front-user/services/e-booking/shared/services/agent.service';
import { ResponseObject } from '../../models/response-object.model';
import { LongHaulService } from '../../services/long-haul.service';

@Component({
  selector: 'app-request-details',
  templateUrl: './request-details.component.html',
  styleUrls: ['./request-details.component.css']
})
export class RequestDetailsComponent implements OnInit {

  @Input() baseRequest: BaseRequest;
  RequestId: string;
  displayedLang: any;
  Languages = Languages;
  isAdmin: boolean = true;
  user = new User();
  registerationTypeId: number;
  requestorId: string;
  url: string;
  isOffline: boolean = false;
  isPortal: boolean = false;
  isAgent: boolean = false;
  service: number;
  Service = Service;
  longHaulReleaseCreatorName: string = "";
  isLongHaulReleaseRequest: boolean = false;
  requestStatuses: string;
  //isRendered: boolean = false;
  constructor(private route: ActivatedRoute, private baseRequestService: BaseRequestService,
    private global: GlobalServices, private authSrevice: AuthenticationService,
    private agentSrv: AgentService, private longhaulserv: LongHaulService) {
    this.displayedLang = this.global.getLanguage();
    this.isAdmin = this.authSrevice.currentUserValue.IsAdmin;
    //this.isAdmin = this.global.user.IsAdmin;
  }

  ngOnInit() {
    if (this.baseRequest) {
      if (this.baseRequest.RequestorId != null && this.baseRequest.RequestorId != undefined && this.baseRequest.RequestorId !== '00000000-0000-0000-0000-000000000000') {
        this.getBaseUser(this.baseRequest.RequestorId);
      } else if (this.baseRequest.RequestorId === '00000000-0000-0000-0000-000000000000') { // Longhaul Release Requests created by admin
        this.isLongHaulReleaseRequest = true;
        // this.getLongHaulReleaseCreator(this.baseRequest.CreatedBy);
      }
    }
    else {
      if (history.state.data && history.state.data.requestId)
        this.RequestId = history.state.data.requestId;
      this.getbaseRequest();
    }
  }

  getbaseRequest() {
    this.baseRequestService.getBaseRequest(this.RequestId).subscribe(
      r => {

        this.baseRequest = r.Data;
        this.service = this.baseRequest.ServiceId;
        if (this.baseRequest.ServiceId == Service.TransitRequest && this.baseRequest.RequestStatuses != null && this.baseRequest.RequestStatuses.length > 0) {
          this.requestStatuses = this.displayedLang == Languages.English ? this.baseRequest.RequestStatuses.filter(s => !Object.values(PenaltyStatus).includes(s.StatusId)).map(s => s.Status.StatusEN).join(', ') : this.baseRequest.RequestStatuses.filter(s => !Object.values(PenaltyStatus).includes(s.StatusId)).map(s => s.Status.StatusAR).join(', ');
        }
        if (this.baseRequest.RequestorId != null && this.baseRequest.RequestorId != undefined && this.baseRequest.RequestorId !== '00000000-0000-0000-0000-000000000000') {
          this.getBaseUser(this.baseRequest.RequestorId);
        } else if (this.baseRequest.RequestorId === '00000000-0000-0000-0000-000000000000') { // Longhaul Release Requests created by admin
          this.isLongHaulReleaseRequest = true;
          // this.getLongHaulReleaseCreator(this.baseRequest.CreatedBy);
        }
      });
  }
  getBaseUser(requestorId: string) {
    this.baseRequestService.getBaseUser(requestorId).subscribe(
      r => {
        this.registerationTypeId = r.Data.RegistrationTypeId;
        if (this.registerationTypeId == RegisterType.Agent) {
          this.isAgent = true;
          this.getAgentOnly(requestorId);
        }
        if (this.registerationTypeId == RegisterType.PortalUser) {
          this.isPortal = true;
          this.url = '#/userprofile?UserID=' + requestorId;
        }
      }
    );
  }
  getAgentOnly(requestorId) {
    this.agentSrv.GetAgentOnly(requestorId).subscribe(d => {
      if (d.Success) {
        this.isOffline = d.Data.IsOffline;
        this.url = '#/register?UserID=' + requestorId;
      }
    });
  }

  // getLongHaulReleaseCreator(creatorEmail: string) {
  // this.longhaulserv.getLongHaulReleaseCreator(creatorEmail).subscribe(
  //   (resObj: ResponseObject) => {
  //     if (resObj.Success) {
  //       this.longHaulReleaseCreatorName = resObj.Data.UserName;
  //     }
  //   }
  // )
  // }
}
